import { gql } from '@apollo/client';

export const GET_STATISTICS = gql`
  query GetStatistics {
    statistics {
      activeUsersCount
      toolsCount
      completedLendsCount
    }
  }
`;
